import React from "react";
import { Button, Modal } from "antd";
import { FcStart } from "react-icons/fc";

class AppWorks extends React.Component {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    return (
      <div id="works" className="block worksBlock">
        <div className="container-fluid">
          <div className="titleHolder">
            <h2>How it works</h2>
            <p>Below is a video tutorial of how famis works.</p>
          </div>
          <div className="contentHolder">
            <Button size="large" onClick={this.showModal}>
              <FcStart />
            </Button>
          </div>
          <Modal
            title="Famis Tutorial"
            open={this.state.visible}
            onCancel={this.handleCancel}
            footer={null}
            destroyOnClose={true}
          >
            <iframe
              title="Famis Tutorial"
              width="100%"
              height="350"
              src=""
            ></iframe>
          </Modal>
        </div>
      </div>
    );
  }
}

export default AppWorks;
